module.exports = __webpack_public_path__ + "media/fonts/Oricons-bfdf505dde213a24d8c4272ec0ccab51.woff";